import { CaseArtefact, PageState } from '../types';

interface StateInput {
  caseArtefacts: CaseArtefact[] | null;
  caseArtefactsPending: boolean;
  caseArtefactsError: number | null;
}

export function resolvePageState(input: StateInput): PageState {
  const { caseArtefacts, caseArtefactsPending, caseArtefactsError } = input;

  if (caseArtefactsError === 401) {
    return { kind: 'no-access' };
  }

  if (caseArtefactsPending && caseArtefacts === null) {
    return { kind: 'loading' };
  }

  if (caseArtefacts && caseArtefacts.length > 0) {
    return { kind: 'ready', artefacts: caseArtefacts };
  }

  return { kind: 'empty' };
}
